module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-medium.d07e666e8e789c1a95b1bc1384618c51.svg";